import dayjs from 'dayjs';
const relativeTime = () => import('dayjs/plugin/relativeTime');
const filters = {
    naira: function (value) {
        //return '₦' + new Intl.NumberFormat({ maximumFractionDigits: 2, currency: 'NGN', currencyDisplay: 'symbol' }).format(Number(value));
        return new Intl.NumberFormat('en-US', { maximumFractionDigits: 2, currency: 'NGN', currencyDisplay: 'symbol', style: 'currency' }).format(Number(value));

    },
    viewingType: function (value) {
        let viewingType = '';
        switch (value) {
            case 0:
                viewingType = 'Virtual';
                break;
            case 1:
                viewingType = 'Physical';
                break;

            default:
        }
        return viewingType;
    },

    currency: function (value, currency) {
        //return '₦' + new Intl.NumberFormat({ maximumFractionDigits: 2, currency: 'NGN', currencyDisplay: 'symbol' }).format(Number(value));

        if (currency === undefined || currency === '' || currency === ' ') {
            currency = 'NGN';
        }
        return new Intl.NumberFormat('en-US', { maximumFractionDigits: 2, currency: `${currency}`, currencyDisplay: 'symbol', style: 'currency' }).format(Number(value));

    },
    billing: function (value) {
        let rate = '';
        switch (value) {
            case 0:
                rate = 'Daily';
                break;
            case 1:
                rate = 'Weekly';
                break;
            case 2:
                rate = 'Monthly';
                break;
            case 3:
                rate = 'Quarterly';
                break;
            case 4:
                rate = 'BiAnnually';
                break;
            case 5:
                rate = 'Yearly';
                break;
            default:
        }
        return rate;
    },

    billingString: function (value) {
        let rate = '';
        switch (value) {
            case 0:
                rate = 'Day(s)';
                break;
            case 1:
                rate = 'Week(s)';
                break;
            case 2:
                rate = 'Month(s)';
                break;
            case 3:
                rate = 'Quarter(s)';
                break;
            case 4:
                rate = 'BiAnnually';
                break;
            case 5:
                rate = 'Yearly';
                break;
            default:
        }
        return rate;
    },
    html: function (value) {
        let parser = new DOMParser;
        let dom = parser.parseFromString(
            '<!doctype html><body>' + value,
            'text/html');
        let decodedString = dom.body.textContent;

        return decodedString;
    },
    tenure: function (value) {
        let duration = value.duration;
        let tenure = '';
        switch (value.period) {
            case 0:
                tenure = 'Day(s)';
                break;
            case 1:
                tenure = 'Week(s)';
                break;
            case 2:
                tenure = 'Month(s)';
                break;
            case 3:
                tenure = 'Year(s)';
                break;
            default:
        }

        return `${duration} ${tenure}`;
    },
    eligibilityStatus: function (value) {
        switch (value) {
            case 0:
                return "Pending";
            case 1:
                return "Not Applicable";
            case 2:
                return "Ineligible";
            case 3:
                return "Eligible";
            default:
                return "";
        }
    },
    period: function (value) {

        switch (value) {
            case 0:
                return "Mornings";
            case 1:
                return "Afternoons";
            case 2:
                return "Evenings";
            default:
                return "";
        }
    },
    times: function (value) {

        switch (value) {
            case 0:
                return "9am to 11am";
            case 1:
                return "12pm to 3pm";
            case 2:
                return "4pm to 7pm";
            default:
                return "";
        }
    },
    frequency: function (value) {
        switch (value) {
            case 1:
                return "Mondays";
            case 2:
                return "Tuesdays";
            case 3:
                return "Wednesdays";
            case 4:
                return "Thursdays";
            case 5:
                return "Fridays";
            case 6:
                return "Saturdays";
            case 0:
                return "Sundays";
            default:
                return "";
        }
    },
    date: function (value) {
        if (value) {
            return dayjs(value).format('DD MMMM, YYYY');
        } else {
            return "";
        }
    },
    time: function (value) {
        return dayjs(value).format('hh:mm a');
    },
    timepassed: function (value) {
        return dayjs().from(value);
    },
    status: function (value) {
        switch (value) {
            case 0:
                return "Pending";
            case 1:
                return "Accepted";
            case 2:
                return "Rejected";
            case 3:
                return "Cancelled";
            default:
                return "";
        }
    },

    includeFee: function (value) {
        let transactionFee = value * 0.1;
        let raveFee = (value + transactionFee) * 0.015 + 10;
        if (raveFee >= 2000) {
            raveFee = 2000 + 10;
        }

        return value + transactionFee + raveFee;
    },
    subscriptionFee: function (value) {
        let transactionFee = value * 0.1;
        return transactionFee;
    },
    raveFee: function (value) {
        let raveFee = (value * 0.015) + 10;
        if (raveFee >= 2000) {
            raveFee = 2000 + 10;
        }
        return raveFee;
    },
    contingencyFee: function(value){
        const contingencyFee = value * 0.05;
        return contingencyFee;
    },
    removeHostFee: function (value) {
        let transactionFee = value * 0.04;
        return value - transactionFee;
    },

    paymentstatus: function (value) {
        switch (value) {
            case 0:
                return "Unpaid";
            case 1:
                return "Paid";
            case 2:
                return "Settled";
            case 3:
                return "Cancelled";
            case 4:
                return "Expired";
            default:
                return "";
        }
    },
    verificationStatus: function (value) {
        return value === true ? 'Yes' : 'No';
    },

    placePhoto: function (photoReference) {
        let url = `https://maps.googleapis.com/maps/api/place/photo?maxwidth=480&photoreference=${photoReference}&key=AIzaSyA-UqcVbHcwFt4842zq8hNhQfX3vUD-hwE`;
        return url;
    },

    subscriptionStatus: function (value) {
        //public enum Status {
        //    Available, //Open for rent  = 0
        //    Rented, //Rented with valid tenancy = 1
        //    Closed //Closed and recreated for rent i.e. closed after rental tenure expired  = 2
        //}

        switch (value) {
            case 0:
                return "Available";
            case 1:
                return "Rented";
            case 2:
                return "Closed";
        }
    },

    genderType: function (value) {
        if (value === 1) {
            return "Female";
        } else if (value === 0)
            return "Male";
        else
            return "";
    }
};

export default filters;